import React from 'react';

import styled from 'styled-components';
import useTranslation from 'next-translate/useTranslation';
import * as colors from '../../api/style';

import { People } from './Icons';
import { TextBold14, TextRegular14 } from './Text';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 22px;
`;

const ProfileFollowersLabel = ({
  style,
  followers,
}: {
  style?: React.CSSProperties;
  followers?: number;
}) => {
  const { t } = useTranslation('profile');
  if (!followers) {
    return null;
  }

  return (
    <Container style={style}>
      <People size={14} color="#000" />
      &nbsp;
      <TextBold14>{followers}</TextBold14>
      &nbsp;
      <TextRegular14 style={{ color: colors.grey_dark_new }}>
        {t('profile:followers')}
      </TextRegular14>
    </Container>
  );
};

export default ProfileFollowersLabel;
